console.log("Modal script loaded");

// ---------- Helpers ----------
let CQM_BUY_NOW_ORIGINAL_HTML = null;

function cqmFormatMoney(cents, currency = "₹") {
  return currency + (cents / 100).toLocaleString("en-IN", {
    minimumFractionDigits: 2
  });
}

// Global state
let cqmProduct = null;
let cqmSelectedOptions = {};
let cqmSelectedVariant = null;

// ---------- CART COUNT ----------
async function cqmUpdateCartCountAndBubble() {
  try {
    const res = await fetch("/cart.js");
    if (!res.ok) return;
    const cart = await res.json();

    document
      .querySelectorAll('[data-testid="cart-bubble"], .cart-bubble__text-count, .cart-count')
      .forEach((el) => (el.textContent = cart.item_count));
  } catch (err) {
    console.warn("Cart count update failed", err);
  }
}

// ---------- Build Options ----------
function cqmBuildOptions(preselectedOptions = {}) {
  const colorWrapper = document.getElementById("cqm-color-wrapper");
  const sizeWrapper = document.getElementById("cqm-size-wrapper");
  const colorContainer = document.getElementById("cqm-color-options");
  const sizeContainer = document.getElementById("cqm-size-options");

  colorContainer.innerHTML = "";
  sizeContainer.innerHTML = "";

  const options = cqmProduct.options || [];
  const colorOption = options.find(o => o.name.toLowerCase().includes("color"));
  const sizeOption = options.find(o => o.name.toLowerCase().includes("size"));

  cqmSelectedOptions = {};

  if (colorOption) {
    colorWrapper.style.display = "block";
    const defaultColor =
      preselectedOptions[colorOption.name] || colorOption.values[0];

    colorOption.values.forEach(val => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cqm__pill";
      btn.textContent = val;
      btn.dataset.optionName = colorOption.name;
      btn.dataset.optionValue = val;
      colorContainer.appendChild(btn);
    });

    cqmSelectedOptions[colorOption.name] = defaultColor;
  } else {
    colorWrapper.style.display = "none";
  }

  if (sizeOption) {
    sizeWrapper.style.display = "block";
    const defaultSize =
      preselectedOptions[sizeOption.name] || sizeOption.values[0];

    sizeOption.values.forEach(val => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cqm__pill";
      btn.textContent = val;
      btn.dataset.optionName = sizeOption.name;
      btn.dataset.optionValue = val;
      sizeContainer.appendChild(btn);
    });

    cqmSelectedOptions[sizeOption.name] = defaultSize;
  } else {
    sizeWrapper.style.display = "none";
  }

  cqmUpdateOptionActiveStates();
  cqmUpdateVariant();
}

function cqmUpdateVariant() {
  const variants = cqmProduct.variants;

  const match = variants.find((v) => {
    const opts = [v.option1, v.option2, v.option3].filter(Boolean);
    return (cqmProduct.options || []).every((opt, index) => {
      const selectedVal = cqmSelectedOptions[opt.name];
      return !selectedVal || selectedVal === opts[index];
    });
  });

  cqmSelectedVariant = match || variants[0];

  document.getElementById("cqm-price").textContent =
    cqmFormatMoney(cqmSelectedVariant.price);

  const compareEl = document.getElementById("cqm-compare");

  if (cqmSelectedVariant.compare_at_price > cqmSelectedVariant.price) {
    compareEl.textContent =
      cqmFormatMoney(cqmSelectedVariant.compare_at_price);
  } else {
    compareEl.textContent = "";
  }

  if (cqmSelectedVariant.featured_image?.src) {
    const imgEl = document.getElementById("cqm-image");
    if (imgEl && cqmSelectedVariant.featured_image?.src) {
      imgEl.src = cqmSelectedVariant.featured_image.src;
    }
  }

  // document.getElementById("cqm-add-to-cart").dataset.variantId =
  //   cqmSelectedVariant.id;

  document.getElementById("cqm-variant-id").value =
  cqmSelectedVariant.id;
}

function cqmUpdateOptionActiveStates() {
  document.querySelectorAll(".cqm__pill").forEach((btn) => {
    btn.classList.toggle(
      "cqm__pill--active",
      cqmSelectedOptions[btn.dataset.optionName] === btn.dataset.optionValue
    );
  });
}

// ---------- Modal ----------
function cqmOpenModal() {
  document.getElementById("custom-quick-modal")
    .classList.remove("cqm--hidden");
}

function cqmCloseModal() {
  document.getElementById("custom-quick-modal")
    .classList.add("cqm--hidden");

  const qtyInput = document.getElementById("cqm-qty");
  if (qtyInput) qtyInput.value = 1;
}

// ---------- EVENTS ----------
document.addEventListener("click", async function (e) {

  const modal = document.getElementById("custom-quick-modal");

  // If click is inside modal, stop event from reaching theme listeners
  if (modal && modal.contains(e.target)) {
    e.stopPropagation();
  }

    // QUICK VIEW OPEN (delegated)
  const quickBtn = e.target.closest(".custom-quick-add-btn");
  if (quickBtn) {
    e.preventDefault();

    // const raw = quickBtn.dataset.product;
    // if (!raw) return;

    // cqmProduct = JSON.parse(raw);


    const handle = quickBtn.dataset.productHandle;
    if (!handle) return;

    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error("Product fetch failed");
      cqmProduct = await res.json();
    } catch (err) {
      console.error("Quick add: failed to load product", err);
      return;
    }

    // Normalize options
    if (Array.isArray(cqmProduct.options) && typeof cqmProduct.options[0] === "string") {
      cqmProduct.options = cqmProduct.options.map((name, index) => {
        const values = [
          ...new Set(
            cqmProduct.variants.map(v => v["option" + (index + 1)]).filter(Boolean)
          )
        ];
        return { name, values };
      });
    }

    cqmOpenModal();

    document.getElementById("cqm-title").textContent = cqmProduct.title;

    const imgEl = document.getElementById("cqm-image");

    if (typeof cqmProduct.featured_image === "string") {
      imgEl.src = cqmProduct.featured_image;
    } else if (cqmProduct.featured_image?.src) {
      imgEl.src = cqmProduct.featured_image.src;
    } else if (cqmProduct.images?.length) {
      imgEl.src = cqmProduct.images[0];
    }

    // cqmBuildOptions({});


    const preselectedVariantId = quickBtn.dataset.selectedVariantId;
    let preselected = {};

    if (preselectedVariantId) {
      const matchedVariant = cqmProduct.variants.find(
        v => String(v.id) === String(preselectedVariantId)
      );
      if (matchedVariant) {
        (cqmProduct.options || []).forEach((opt, index) => {
          const optName = typeof opt === "string" ? opt : opt.name;
          preselected[optName] = matchedVariant["option" + (index + 1)];
        });
      }
    }

    cqmBuildOptions(preselected);

    if (matchedVariant?.featured_image?.src) {
      imgEl.src = matchedVariant.featured_image.src;
    }

    return;
  }

  // CLOSE
  if (e.target.matches(".cqm__close") || e.target.matches(".cqm__overlay")) {
    cqmCloseModal();
    return;
  }

  // OPTION SELECT
  const optionBtn = e.target.closest(".cqm__pill");
  if (optionBtn) {
    cqmSelectedOptions[optionBtn.dataset.optionName] =
      optionBtn.dataset.optionValue;
    cqmUpdateOptionActiveStates();
    cqmUpdateVariant();
    return;
  }

  // QTY
  const qtyBtn = e.target.closest(".cqm__qty-btn");
  if (qtyBtn) {
    const change = Number(qtyBtn.dataset.qtyChange);
    const input = document.getElementById("cqm-qty");
    input.value = Math.max(1, Number(input.value || 1) + change);
    return;
  }

  // ADD TO CART
  // if (e.target.id === "cqm-add-to-cart") {
  //   const variantId = Number(e.target.dataset.variantId);
  //   const qty = Number(document.getElementById("cqm-qty").value) || 1;

  //   await fetch("/cart/add.js", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({ id: variantId, quantity: qty })
  //   });

  //   await cqmUpdateCartCountAndBubble();
  //   await cqmRefreshCartDrawerFromHeader();

  //   cqmCloseModal();
  //   document.querySelector("cart-drawer-component")?.open?.();
  // }

  if (e.target.id === "cqm-view-cart") {
    window.location.href = "/cart";
  }
});

// ---------- QUICK VIEW OPEN ----------


document.getElementById("cqm-product-form")?.addEventListener("submit", async function(e) {
  e.preventDefault();

  const form = e.target;

  const button = form.querySelector("#cqm-add-to-cart");

  const text = button.querySelector(".btn-text");
  const loader = button.querySelector(".btn-loader");

  // 🔥 START LOADING
  button.disabled = true;
  text.style.display = "none";
  loader.style.display = "inline-block";

  const formData = new FormData(form);

  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      body: formData
    });

    if (!res.ok) throw new Error("Add to cart failed");

    // 🔥 Trigger theme cart update
    await new Promise(r => setTimeout(r, 200)); // IMPORTANT (Shopify delay)

    await updateCartCount();

    await cqmRefreshCartDrawerFromHeader();

    // ✅ RESET BUTTON
    button.disabled = false;
    text.style.display = "inline";
    loader.style.display = "none";

    cqmCloseModal();

    document.querySelector("cart-drawer-component")?.open?.();

    // 🔥 Open drawer
    document.querySelector("cart-drawer-component")?.open?.();

  } catch (err) {
    console.error(err);
  }
});

async function updateCartCount() {
  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    const countEl = document.querySelector("#cart-bubble-text");

    if (countEl) {
      countEl.textContent = cart.item_count;
    }

  } catch (err) {
    console.error("Cart count update failed", err);
  }
}

// const bubble = document.querySelector(".cart-bubble");

// if (bubble) {
//   bubble.style.display = cart.item_count > 0 ? "flex" : "none";
// }



// ESC
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") cqmCloseModal();
});



async function cqmRefreshCartDrawerFromHeader() {
  const drawer = document.querySelector("cart-drawer-component");
  const itemsComp = drawer?.querySelector("cart-items-component");
  if (!drawer || !itemsComp) return;

  const sectionId = itemsComp.dataset.sectionId;
  if (!sectionId) return;

  try {
    const res = await fetch(`/?section_id=${sectionId}`);
    if (!res.ok) return;

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");

    const newItemsComp = doc.querySelector("cart-items-component");
    if (newItemsComp) {
      itemsComp.innerHTML = newItemsComp.innerHTML;
      document.dispatchEvent(new CustomEvent("cart:changed"));
    }
  } catch (err) {
    console.error("Failed to refresh cart drawer", err);
  }
}




const SIZE_GUIDE_JSON_URL =
  "https://thefunkydelicstore.in/cdn/shop/t/15/assets/size-guide.json";


// ---------- SIZE CHART HANDLER ----------
document.addEventListener("click", async function (e) {
  if (!e.target.classList.contains("cqm-size-chart-btn")) return;

  e.preventDefault();

  const modal = document.getElementById("custom-quick-modal");
  const content = document.getElementById("cqm-content");
  const productType = cqmProduct?.type?.trim();

  if (!modal || !content || !productType) {
    console.warn("Size chart modal requirements missing.", {
      modal,
      content,
      productType
    });
    return;
  }

  // Hide main modal content
  content.style.opacity = "0";
  content.style.pointerEvents = "none";

  // Overlay container
  let overlay = document.getElementById("cqm-size-guide-overlay");
  if (!overlay) {
    overlay = document.createElement("div");
    overlay.id = "cqm-size-guide-overlay";
    overlay.style.cssText = `
      position:absolute;
      inset:0;
      display:flex;
      align-items:center;
      justify-content:center;
      background:rgba(0,0,0,0.85);
      z-index:99999;
      padding:20px;
      box-sizing:border-box;
    `;

    const closeBtn = document.createElement("button");
    closeBtn.textContent = "×";
    closeBtn.setAttribute("aria-label", "Close size guide");
    closeBtn.style.cssText = `
      position:absolute;
      top:12px;
      right:20px;
      font-size:32px;
      background:transparent;
      color:#fff;
      border:none;
      cursor:pointer;
    `;

    closeBtn.onclick = () => {
      overlay.style.display = "none";
      content.style.opacity = "1";
      content.style.pointerEvents = "auto";
    };

    const img = document.createElement("img");
    img.id = "cqm-size-guide-img";
    img.className = "cqm-size-guide-img";

    overlay.append(closeBtn, img);
    modal.appendChild(overlay);
  }

  const img = document.getElementById("cqm-size-guide-img");
  img.src = "";
  overlay.style.display = "flex";

  // ---- FETCH FROM REAL JSON URL ----
  try {
    const res = await fetch(SIZE_GUIDE_JSON_URL);
    if (!res.ok) throw new Error("Size guide fetch failed");

    const data = await res.json();

    img.src =
      data[productType] ||
      "https://via.placeholder.com/700x700?text=Size+Guide+Unavailable";
  } catch (err) {
    console.error("Size guide load error:", err);
    img.src = "https://via.placeholder.com/700x700?text=Size+Guide+Error";
  }
});